<template>
	<section>
		<fixed-header title="Bill Payments List" :records="pageInfo.totalItems">
			<template v-slot:center>
				<b-dropdown variant="primary" size="sm" text="Post Payment" class="ml-2" v-if="checkClaim(CAN_POST_PAYMENT)">
          <b-dropdown-item @click="add(1)"><i class="fa fa-plus" aria-hidden="true"></i> Purchase Order </b-dropdown-item>
          <b-dropdown-item @click="add(2)"><i class="fa fa-plus" aria-hidden="true"></i> Work Order </b-dropdown-item>
        </b-dropdown>
			</template>
		</fixed-header>
		<div class="animated fadeIn BillPayments--BillPayments-list">
			<div class="card margin-top-fixed-header h-50">
				<div class="card-body d-flex flex-column">
					<div class="d-flex justify-content-start align-items-end mb-2">
						<b-form-group label="Purchase Order Number" class="mr-2">
						<b-form-input v-model="filters.purchaseOrderId" size="sm" type="text" @input="onSearch"></b-form-input>
						</b-form-group>
						<b-form-group label="CompanyName " class="mr-2">
						<b-form-input v-model="filters.companyName" size="sm" type="text" @input="onSearch"></b-form-input>
						</b-form-group>
						<date-range-picker ref="dateRangePicker" :handleSearch="search"></date-range-picker>
						<div class="clear-filter-button-container">
						<b-button size="sm" @click="handleClearFilter">Clear filters</b-button>
						</div>
					</div>
					<grid-component
							isResizable
							isReorderable
							isSortable
              :canEdit="checkClaim(CAN_POST_PAYMENT)"
              :canDelete="checkClaim(CAN_POST_PAYMENT)"
							:gridId="gridId"
							:pageable="pageable"
              :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
              :take="pageInfo.pageSize"
							:itemData="itemData"
							:pageSizes="pageInfo.pageSize"
							:totalItems="pageInfo.totalItems"
							:fields="fields"
							:sortBy="pageInfo.sortBy"
							:sortOrder="pageInfo.sortOrder"
							:sortMethod="sortGrid"
							:handleRowClick="handleRowClick"
							:onDelete="onDelete"
							@getData="onGetData"
              :isTblLoader="tblLoader"
						/>
				</div>
			</div>
		</div>
		<b-card>
			<b-tabs class="d-flex flex-column">
				<b-tab title="Payment details">
					<payment-details :billPaymentId="selectedRowItemId" />
				</b-tab>
			</b-tabs>
		</b-card>
	</section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import  debounce from 'lodash/debounce';

import { dateTime, date } from '@/shared/filters';
import { SEARCH_DEBOUNCE_TIME, GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import DateFilters from '@/shared/components/DateFilters';
import FixedHeader from '@/shared/components/FixedHeader/index';
import DateRangePicker from '@/shared/components/DateRangePicker';
import GridComponent from '@/shared/components/GridComponent';
import PaymentDetails from './components/PaymentDetails'

import gridFields from './fields';


export default {
	components: {
		DateFilters,
		GridSettings,
		FixedHeader,
		DateRangePicker,
		GridComponent,
		PaymentDetails
  },
  metaInfo: () => ({
    title: 'Bill Payments',
  }),
	data() {
		return {
			prepareColumnsData,
			fields: gridFields,
			date,
			gridId: GRID_ID.BILL_PAYMENTS,
			pageable: {
				pageSizes: GRID_PAGE_SIZES,
			},
			selectedRowItemId: 0,
		};
	},
	computed: {
		...mapState('billPayments', ['lastOpenedId']),
		...mapGetters('billPayments', [
			'gridList',
			'billPayment',
			'pageInfo',
			'selectedItemId' ,
			'filters',
			'dateRange',
			'tblLoader',
		]),
		...mapGetters('account', ['gridSettingsById']),
		gridSettings() {
			return this.gridSettingsById(this.gridId);
		},
		itemData() {
      if (this.gridList == undefined || !this.gridList.length) return [];
			return this.gridList.map((BillPayment) => ({ ...BillPayment, selected: BillPayment.id === this.selectedRowItemId }));
		},
	},
	filters: {
		dateTime,
	},
	methods: {
		...mapMutations('billPayments', [
			'setFilters',
			'setItem',
		]),
		...mapActions('billPayments', ['getAll',
		 'getById',
		 'deleteById',
		 'sortGrid',
		 'getPage',
		 'search',
		 'select',
		 'clearFilters',
		 'select']),
		...mapActions('account', ['saveGridSettings']),
		onSearch: debounce(function () {
			this.search(this.filters);
		}, SEARCH_DEBOUNCE_TIME),
		async handleClearFilter() {
			this.clearFilters();
			/*Object.keys(this.filters).forEach(filterName => {
				this.filters[filterName] = null;
			});
			this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker*/
			await this.search(this.filters);
		},
    add(sourceId) {
      this.$router.push({ name: 'billpayments.add', params: { sourceId: sourceId } });
    },
		handleRowClick(row) {
			/*this.setLastOpenedId(row.dataItem.id);*/

      this.setItem({ resource: 'lastOpenedId', payload: row.dataItem.id });

			this.selectedRowItemId = row.dataItem.id;
			const { id, detailsVisible } = row.dataItem;
      		this.select({ id, isChecked: !detailsVisible });
		},
    async onDelete({ id }) {
      const deleteConfirmed = await this.openConfirmBox({ message: 'Are you sure you want to delete bill payment?  This action cannot be undone.' });
      if (deleteConfirmed) {
        await this.deleteById(id);
        //Get the data
        await this.getAll({});
      }
    },
		async onGetData(params) {
			await this.getAll(params);
		},
	},
	watch: {
		async gridList() {
			//This function sets the first row as the selected row
      this.selectedRowItemId = await this.setSelectedRowId(this.gridList,this.selectedRowItemId,this.lastOpenedId);
		},
	},
  async mounted() {
		if(this.lastOpenedId) {
			this.selectedRowItemId = this.lastOpenedId;
		}
    this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
    await this.getAll({});
	},
	beforeDestroy() {
		//this.select({ id: null, isChecked: false });
	},
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#BillPayments-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
}

#BillPayments-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}


.BillPayments {
  &--BillPayments-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }

    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
	min-width: 800px;
}
</style>
